import { createAction, props } from '@ngrx/store';
import {
  FormularyEntity,
  FormularyRequest,
  ServiceError,
} from './formulary.models';

export const loadFormulary = createAction(
  '[Formulary] Load Formulary',
  props<{
    formularyRequest: FormularyRequest;
    isPublic: boolean;
    loadMore: boolean;
  }>(),
);

export const loadFormularySuccess = createAction(
  '[Formulary] Load Formulary Success',
  props<{ formulary: FormularyEntity; loadMore: boolean }>(),
);

export const loadFormularyFailure = createAction(
  '[Formulary] Load Formulary Failure',
  props<{ error: ServiceError }>(),
);
